import { apiCall, ApiConfig } from '../../config/api'
import { getSuppliersAction } from '../actions/SupplierOriginActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { supplierOriginActionsTypes } from '../types/supplierOriginActionsTypes'
import { SupplierOrigin } from '../../interfaces/Supplier/Supplier'

export function* getSuppliersOriginAsync() {
  try {
    const {
      status,
      data
    }: AxiosResponse<{
      pageIndex: number
      pageSize: number
      totalPages: number
      totalItems: number
      items: SupplierOrigin[]
    }> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.SupplierOriginApi}?pageSize=500`
    )
    if (status === 200) {
      yield put(getSuppliersAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getSuppliersAction([], serverError.message))
  }
}

export function* watchGetSupplierOriginAsync() {
  yield takeEvery(
    supplierOriginActionsTypes.GET_SUPPLIERS_ORIGIN,
    getSuppliersOriginAsync
  )
}
